// Copyright 2020, J. Donald Tillman.  All rights reserved.
// Waveform Workbench app.
// Pretty slider for data entry.

import React from 'react';
import styled from 'styled-components';

// The caller is responsible to convert the value to an integer 0 to range.
export const Slider = (props) => {
    const { label, value, range, onChange, readout } = props;

    return (<Wrapper>
              <Label>{label}</Label>
              <Input type="range"
                     min={0}
                     max={range}
                     value={value}
                     onChange={e => onChange && onChange(e.target.value)}/>
	      {<Readout>{'' + readout}</Readout>}
            </Wrapper> );
};

const Wrapper = styled.div`
   display: flex;
   justify-content: space-between;
   align-items: center;
   padding: 10px 0;
`;

const Label = styled.div`
   width: 100px;
`;

const Readout = styled.div`
    width: 100px;
`;

// this mess assembled with the help of
// http://danielstern.ca/range.css
const Input = styled.input`
    width: 400px;
    height: 30px;
    -webkit-appearance: none;
   :focus {
  outline: none;
}
    ::-webkit-slider-runnable-track {
  width: 100%;
  height: 6px;
  cursor: pointer;
  box-shadow: 1px 1px 1px #000000, 0px 0px 1px #0d0d0d;
  background: #969696;
  border-radius: 1px;
  border: 0.2px solid #010101;
}
    ::-webkit-slider-thumb {
  box-shadow: 1.1px 1.1px 3px #000000, 0px 0px 1.1px #0d0d0d;
  border: 1px solid #000000;
  height: 36px;
  width: 16px;
  border-radius: 3px;
  background: rgba(142, 99, 66, 0.52);
  cursor: pointer;
  -webkit-appearance: none;
  margin-top: -15.2px;
}
    ::-moz-range-track {
  width: 100%;
  height: 6px;
  cursor: pointer;
  box-shadow: 1px 1px 1px #000000, 0px 0px 1px #0d0d0d;
  background: #969696;
  border-radius: 1px;
  border: 0.2px solid #010101;
}
    ::-moz-range-thumb {
  box-shadow: 1.1px 1.1px 3px #000000, 0px 0px 1.1px #0d0d0d;
  border: 1px solid #000000;
  height: 36px;
  width: 16px;
  border-radius: 3px;
  background: rgba(142, 99, 66, 0.52);
  cursor: pointer;
}
    ::-ms-track {
  width: 100%;
  height: 6px;
  cursor: pointer;
  background: transparent;
  border-color: transparent;
  color: transparent;
}
    ::-ms-fill-lower {
  background: #898989;
  border: 0.2px solid #010101;
  border-radius: 2px;
  box-shadow: 1px 1px 1px #000000, 0px 0px 1px #0d0d0d;
}
    ::-ms-fill-upper {
  background: #969696;
  border: 0.2px solid #010101;
  border-radius: 2px;
  box-shadow: 1px 1px 1px #000000, 0px 0px 1px #0d0d0d;
}
    ::-ms-thumb {
  box-shadow: 1.1px 1.1px 3px #000000, 0px 0px 1.1px #0d0d0d;
  border: 1px solid #000000;
  height: 36px;
  width: 16px;
  border-radius: 3px;
  background: rgba(142, 99, 66, 0.52);
  cursor: pointer;
  height: 6px;
}
`;
